import React, { useEffect, useState } from "react";
import remove_accents from "remove-accents";
import styles from "./Modaly.module.sass";
import {
  csCZ,
  DataGridPremium,
  LicenseInfo,
  useGridApiRef,
} from "@mui/x-data-grid-premium";
import swal from "sweetalert";
import { login, loginData } from "../../../../screens/SignIn/redux/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  dajblubeneUrl,
  menuRunUrl,
  menuUrl,
} from "../../../../features/urlHelper";
import { useHistory } from "react-router";
import { getLicensePremium } from "../../../../features/License";
import useDarkMode from "@fisch0920/use-dark-mode";
import ContentLoader from "react-content-loader";
import Search from "../../../../components/Search";
import { searchData } from "../../../../components/Search/redux/searchSlice";
import ModalForm from "./../../../../components/Modaly/ModalForm";
import {
  Form,
  loadingForm,
} from "../../../../components/Modaly/ModalForm/redux/FormSlice";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { errorHandleDialog } from "../../../../features/errorDialog";

const App = ({ className }) => {
  const apiRef = useGridApiRef();
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(false);
  const [visibleForm, setVisibleForm] = useState(false);
  const [visibleMenuOblibene, setVisibleMenuOblibene] = useState(false);
  //const logindata = useSelector(loginData);
  const logindata = JSON.parse(window.sessionStorage.getItem("logindata") !== null ? window.sessionStorage.getItem("logindata") : "{}");

  const searchdata = useSelector(searchData);
  const [formName, setFormName] = useState("");

  const dispatch = useDispatch();
  const navigate = useHistory();
  const darkMode = useDarkMode(false);
  LicenseInfo.setLicenseKey(getLicensePremium());

  function getWidth(width) {
    if (width > 1056) {
      return 624;
    } else if (width < 1056 && width > 767) {
      return width - 240;
    } else {
      return width - 80;
    }
  }

  const stylingTable = {
    border: 0,
    paddingTop: 2,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    letterSpacing: "normal",
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "& .MuiDataGrid-withBorderColor": {
      borderRight: `1px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
      //border: `1px solid ${darkMode.value ? "white" : "#e0e0e0"}`
      //display: "none",
    },
    "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
      color: darkMode.value ? "white" : "#666d74",
      borderRight: `1px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
    },
    "& .MuiDataGrid-withBorderColor": {
      border: `1px solid ${darkMode.value ? "transparent" : "transparent"}`,
    },

    "& .MuiSvgIcon-root": {
      color: "#a7acaf",
    },
    "& .MuiDataGrid-cell:focus": {
      outline: 0,
    },
    "& .MuiTableRow-root": {
      cursor: "pointer",
    },
    "& .MuiDataGrid-cell--editable": {
      backgroundColor: "rgb(195, 247, 195)",
      color: "black",
      "&:hover": {
        backgroundColor: "rgb(240,250,190)",
      },
      "& .MuiInputBase-root": {
        height: "100%",
      },
    },
    "& .MuiDataGrid-cell": {
      padding: 2,
      borderRight: `1px solid transparent`,
    },
    "& .special-row": {
      display: "flex",
      alighnItems: "center",
      justifyContent: "center",
      cursor: "auto",
      typography: {
        fontSize:
          window.innerWidth < 850 ? (window.innerWidth < 500 ? 12 : 14) : 16,
        fontWeight: 600,
      },
    },

    "& .MuiDataGrid-row": {
      typography: {
        fontSize:
          window.innerWidth < 850 ? (window.innerWidth < 500 ? 12 : 14) : 16,
        fontWeight: 600,
      },
    },
    "& .special-row3:hover": {
      cursor: "pointer",
      color: "#f2c437",
    },

    "& .special-row2": {
      display: "flex",
      alighnItems: "center",
      justifyContent: "center",
      cursor: "auto",

      typography: {
        fontSize:
          window.innerWidth < 850 ? (window.innerWidth < 500 ? 12 : 14) : 16,
        fontWeight: 600,
        color: "#F1B600",
      },
    },
    "& .Mui-error": {
      backgroundColor: "red",
      color: "white",
    },
    "& .separator-true": {
      borderBottom: `3px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
    },
    "& .separator-true-special:hover": {
      typography: {
        fontSize:
          window.innerWidth < 850 ? (window.innerWidth < 500 ? 12 : 14) : 16,
        fontWeight: 600,
        color: "#F1B600",
      },
      cursor: "pointer",
      borderBottom: `3px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
    },
    "& .separator-true-special": {
      typography: {
        fontSize:
          window.innerWidth < 850 ? (window.innerWidth < 500 ? 12 : 14) : 16,
        fontWeight: 600,
      },
      cursor: "auto",
      borderBottom: `3px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
    },
    width: getWidth(window.innerWidth),
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alighnItems: "center",
  };

  const columns = [
    {
      field: "__tree_data_group__",
      headerName: "",
      width: getWidth(window.innerWidth) - (window.innerWidth < 767 ? 50 : 120),
      headerAlign: "center",
      renderCell: (params) => <>aaaaa</>,
    },
    {
      field: "text",
      headerName: "",
      width: "100%",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      groupable: false,
    },
    {
      field: "spustit",
      headerName: "",
      width: window.innerWidth < 767 ? 30 : 100,
      headerAlign: "center",
      sortable: false,
      filterable: false,
      groupable: false,
      renderCell: (params) => (
        <>
          {params.row.rychlaVolba != undefined && params.row.key != "" ? (
            <div className={styles.icons2}>
              {edit ? (
                <div className={styles.star}>
                  {params.row.oblubene ? (
                    <i class="fa fa-star"></i>
                  ) : (
                    <i class="fa fa-star-o"></i>
                  )}
                </div>
              ) : (
                <>
                  {params.row.enabled ? (
                    <div
                      onClick={() => {
                        spustit(params.row.key);
                      }}
                      name={params.row.key}
                      className={styles.spustit}
                    >
                      <i class="fa fa-play"></i>{" "}
                      {window.innerWidth < 767 ? <></> : <>Spustit</>}
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);
    result();
  }, []);

  async function result() {
    await axios
      .post(
        dajblubeneUrl,
        {
          stredisko: logindata.UserData.vybrane_stredisko.kod,
        },
        {
          headers: { Authorization: "Bearer " + logindata.Token },
        }
      )
      .then(function (response) {
        console.log(response);
        setTitle(response.data.title);
        setRows(response.data.menu);
        setLoading(false);
      })
      .catch(function (error) {
        errorHandleDialog(error.response, navigate, dispatch);
      });
  }

  const theme = createTheme({
    palette: {
      primary: { main: "#nnn" },
    },
  });

  async function spustit(key, typ) {
    await axios
      .post(
        menuRunUrl,
        {
          key: key,
          typ: typ,
        },
        {
          headers: { Authorization: "Bearer " + logindata.Token },
        }
      )
      .then(function (response) {
        console.log("spustit", response);
        if (response.data.typ === "route") {
          navigate.push(response.data.url);
        } else if (response.data.typ === "enter") {
          console.log("enterData", response.data.enterData);
          dispatch(loadingForm());
          setFormName(response.data.enterData.formName);
          // let enterData = { ...response.data.enterData, values: {}}
          // let values = {}
          // enterData.sections.map((section, index1) => {
          //       section.fieldsets.map((polozky, index2) => {
          //               polozky.fields.map((polozka) => {
          //                 values = { ...values, [polozka.fieldName]: polozka}
          //               })
          //             })
          //           })
          // let enterData2 = { ...response.data.enterData, values: values}
          dispatch(Form(response.data.enterData));
          console.log(response.data.enterData);
          setVisibleForm(true);
          document
                .getElementsByName(
                  response.data.enterData.values[Object.keys(response.data.enterData.values)[0]].id
                )[0]
                .focus();
        }
        console.log(response);
      })
      .catch(function (error) {
        errorHandleDialog(error.response, navigate, dispatch);
      });
  }

  function isFavoriteMoreThan2(rows) {
    if (rows.filter((row) => row.oblubene).length >= 3) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div className={styles.card}>
      <div style={{ height: "100%" }}>
        {loading ? (
          <ContentLoader
            speed={2}
            width={getWidth(window.innerWidth)}
            height={"100%"}
            backgroundColor={darkMode.value ? "#1e2730" : "#f3f3f3"}
            foregroundColor={darkMode.value ? "#2d3641" : "#ecebeb"}
          >
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map(
              (i) =>
                [0, 1, 2, 3, 4, 5, 6].map((j) => (
                  <rect
                    key={j}
                    x={0}
                    y={2 + i * (window.innerHeight / 20)}
                    rx="3"
                    ry="3"
                    width={"100%"}
                    height={10}
                  />
                ))
            )}
          </ContentLoader>
        ) : (
          <div className={styles.content}>
            <div className={styles.headerOverlay}>
              <div className={styles.header}>
                <div className={styles.title}>{"Oblíbene volby"}</div>
              </div>
              <Search field={"menu"} className={styles.searchHead} />
            </div>
            <ThemeProvider theme={theme}>
              <DataGridPremium
                ref={apiRef}
                sx={stylingTable}
                localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
                columnHeaderHeight={0}
                rowHeight={40}
                defaultGroupingExpansionDepth={-1}
                treeData
                onRowClick={(params, event, details) => {
                  if (
                    params.row.enabled &&
                    params.row.rychlaVolba !== undefined &&
                    params.row.key !== "" &&
                    !edit
                  ) {
                    spustit(params.row.key, params.row.typ);
                  }
                }}
                loading={loading}
                getTreeDataPath={(row) => row.hierarchy}
                hideFooter
                {...{
                  rows: rows.filter((xy) =>
                    String(remove_accents(xy.text.toUpperCase())).includes(
                      remove_accents(searchdata.menu.toUpperCase())
                    )
                  ),
                  columns: columns,
                }}
                initialState={{
                  columns: {
                    columnVisibilityModel: { skupina: false, text: false },
                  },
                }}
                disableRowSelectionOnClick
                groupingColDef={{
                  hideDescendantCount: true,
                }}
                getCellClassName={(params) => {
                  if (
                    params.row.hasSeparator &&
                    params.row.enabled &&
                    params.row.rychlaVolba !== undefined &&
                    params.row.key !== ""
                  ) {
                    return `separator-${params.row.hasSeparator}-special`;
                  }
                  if (params.row.hasSeparator) {
                    return `separator-${params.row.hasSeparator}`;
                  }
                  if (params.row.key == "") {
                    return `special-row`;
                  }
                  if (
                    params.row.rychlaVolba == undefined &&
                    params.id === "auto-generated-row-null/Oblíbené"
                  ) {
                    return `special-row2`;
                  }
                  if (params.row.rychlaVolba == undefined) {
                    return `special-row`;
                  }
                  if (
                    params.row.enabled &&
                    params.row.rychlaVolba !== undefined &&
                    params.row.key !== ""
                  ) {
                    return `special-row3`;
                  }
                }}
                isGroupExpandedByDefault={(row) =>
                  //console.log(row)
                  row.depth === 0 ? true : false
                }
              />
            </ThemeProvider>
          </div>
        )}
      </div>

      <ModalForm
        visible={visibleForm}
        setVisible={setVisibleForm}
        className={styles}
        formName={formName}
      />
    </div>
  );
};
export default App;
